import React from 'react';
import { Grid, Typography, Box, Card, CardContent, Chip } from '@mui/material';
import './FeaturedCard.css';
import { docsAuthors } from '../../../utils/docsData';
import { Link } from 'react-router-dom';
import MathText from '../../Math/MathText';
import DocsPreviewImage from '../../Docs/DocsPreviewImage';

const FeaturedCard = (props) => {
    const author = docsAuthors[props.author_id]?.firstName || props.author_id;

    const truncateText = (text, maxLength) => {
        if (text.length <= maxLength) return text;
        const truncated = text.substring(0, maxLength);
        return truncated.substring(0, truncated.lastIndexOf(' ')) + '...';
    };

    return (
        <Grid item xs={12} mb={8} className="featured-post" mt={2}>
            <Card className="featured-card featured-card-with-preview">
                <DocsPreviewImage postId={props.id} className="featured-image" alt={`${props.title} preview`} />
                <CardContent className="featured-content">
                    {props.category && (
                        <Chip label={props.category} size="small" sx={{ mb: 1, bgcolor: '#2cbb5d', color: '#000' }} />
                    )}
                    <Typography variant="overline" className="featured-label">Featured</Typography>
                    <Typography variant="h4" className="featured-title">{props.title}</Typography>
                    <Box className="featured-meta">
                        <Typography variant="body2">{author}</Typography>
                        <Typography variant="body2">{`${props.comments} comments`}</Typography>
                        <Typography variant="body2">{new Date(props.date).toDateString()}</Typography>
                    </Box>
                    <Typography variant="body1" className="featured-description" component="div">
                        <MathText text={truncateText(props.description, 240)} />
                    </Typography>
                    <Typography variant="body1" className="read-more" width="auto">
                        <Link to={`/docs/post/${props.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                            Read More
                        </Link>
                    </Typography>
                </CardContent>
            </Card>
        </Grid>
    );
};

export default FeaturedCard;
